module.exports = __webpack_public_path__ + "static/img/skyline-bg.b39fa6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/skyline-bg.png
// module id = 680
// module chunks = 64